import React, { ChangeEvent } from 'react';
import { NativeTypes } from 'react-dnd-html5-backend';
import { useDrop, DropTargetMonitor } from 'react-dnd';

import DropAreaImg from '../../assets/image/droparea/bg.svg';
import Button from '@material-ui/core/Button';
import Tr from '../shared/tr';

const style: React.CSSProperties = {
  border: '2px dashed #afafaf',
  height: '25rem',
  width: '35rem',
  padding: '6rem',
  textAlign: 'center',
  display: 'block',
  borderRadius: 4,
};

export interface TargetBoxProps {
  onDrop: (props: TargetBoxProps, monitor: DropTargetMonitor) => void;
  onOpen: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const TargetBox = (props: TargetBoxProps) => {
  const { onDrop, onOpen } = props;
  const [{ canDrop, isOver }, drop] = useDrop({
    accept: [NativeTypes.FILE],
    drop(item, monitor) {
      if (onDrop) {
        onDrop(props, monitor);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const isActive = canDrop && isOver;
  const tr = new Tr();
  return (
    <div ref={drop} style={style}>
      <Button variant="contained" component="label">
        <img src={DropAreaImg} />
        <input accept=".stl,.ply,.dcm" type="file" hidden onChange={onOpen} />
      </Button>
      <div>
        {isActive ? tr.dragAreaReleaseTip() : tr.dragAreaDragTip()}
      </div>

      <div>{tr.dragAreaSupportTip('.DCM/.STL/.PLY')}</div>
    </div>
  );
};
